<template>
  <div class="list-page-layout">
    <el-row type="flex" justify="space-between">
      <!-- 标题 -->
      <el-col class="title-bar" :span="8">
        <slot name="title"></slot>
      </el-col>
      <!-- 操作栏 -->
      <el-col class="action-bar" :span="16">
        <slot name="action-bar"></slot>
      </el-col>
    </el-row>
    <el-row>
      <!-- 搜索框 -->
      <v-card class="search-bar">
        <slot name="search-bar"></slot>
      </v-card>
    </el-row>
    <el-row>
      <!-- 页面主体内容 -->
      <v-card class="main-content">
        <slot name="tabs"></slot>
        <slot name="main-content"></slot>
        <slot>
          <el-pagination
            class="text-center"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
            :page-size="pageSize"
            :current-page="currentPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </slot>
      </v-card>
    </el-row>
  </div>
</template>

<script>
import vCard from '@/components/common/Card'
export default {
  data() {
    return {
    }
  },
  props: {
    total: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
  },
  components: {
    vCard,
  },
  methods: {
    handleSizeChange(pageSize) {
      this.$emit('size-change', pageSize)
    },
    handleCurrentChange(currentPage) {
      this.$emit('current-change', currentPage)
    },
  },
}
</script>

<style lang="less">
.list-page-layout {
  .title-bar {
    margin-top: 10px;
    margin-bottom: 30px;
    p, span, h1, h2, h3, h4, h5, h6 {
      font-size: 26px;
      color: #86939e;
      margin: 0;
    }
  }
  .search-bar {
    margin-bottom: 20px;
  }
  .main-content {
    min-height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// ListPageLayout.vue?58a7be6c